import { Column } from '@landsbankinn/ui';
import React from 'react';
import type { RequestGdprDataInput } from '../../../../__generated__/globalTypes';
import { RequestGdprDataType } from '../../../../__generated__/globalTypes';
import { GdprCheckbox } from './GdprCheckbox';

interface IProps {
  setGdprData: React.Dispatch<React.SetStateAction<RequestGdprDataInput>>;
  gdprData: RequestGdprDataInput;
}

export function CheckboxContainer({ setGdprData, gdprData }: IProps) {
  return (
    <>
      <Column md={{ width: 6 / 12 }}>
        <GdprCheckbox
          type={RequestGdprDataType.Deposit}
          label="Innlán"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Upplýsingar um veltu-, sparireikninga o.fl. (einnig aðgengilegar í netbanka viðskiptavina)."
          tooltipTitle="Innlán"
        />
        <GdprCheckbox
          type={RequestGdprDataType.Loan}
          label="Útlán"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af skuldabréfi, lánasamningi, yfirdrætti og greiðslumati ásamt fylgiskjölum, upplýsingar um lánshæfismat."
          tooltipTitle="Útlán"
        />

        <GdprCheckbox
          type={RequestGdprDataType.Debt}
          label="Innheimtukröfur"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Yfirlit yfir kröfur sem bankinn innheimtir fyrir þriðju aðila (einnig aðgengilegt í netbanka viðskiptavina)."
          tooltipTitle="Innheimtukröfur"
        />

        <GdprCheckbox
          type={RequestGdprDataType.DebtCollection}
          label="Innheimta og vanskil"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af innheimtubréfum, greiðsluáskorunum, stefnu/m kröfulýsingum, afrit af greiðsluerfiðleikamati og fylgiskjölum eftir því sem við á."
          tooltipTitle="Innheimta og vanskil"
        />

        <GdprCheckbox
          type={RequestGdprDataType.Securities}
          label="Verðbréfaviðskipti"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af beiðni um verðbréfaviðskipti og fylgiskjöl, MiFID staðfesting, beiðni um flokkun í verðbréfaviðskiptum, áreiðanleikakönnun o.fl."
          tooltipTitle="Verðbréfaviðskipti"
        />
      </Column>

      <Column md={{ width: 6 / 12 }}>
        <GdprCheckbox
          type={RequestGdprDataType.AssetManagement}
          label="Eignastýring"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af samningi um eignastýringu, fjárfestingastefna, umsókn um innlánsreikning, upplýsingar vegna ráðgjafar o.fl."
          tooltipTitle="Eignastýring"
        />

        <GdprCheckbox
          type={RequestGdprDataType.Pension}
          label="Lífeyrissparnaður"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af samningi um lífeyris- og viðbótarlífeyrissparnað, umsókn um úttektir o.fl."
          tooltipTitle="Lífeyrissparnaður"
        />

        <GdprCheckbox
          type={RequestGdprDataType.CustomerInfo}
          label="Viðskiptavinurinn"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af þjónustusamningum t.d. um aðgang að netbanka og að geymsluhólfi, afrit af skilríkjum, umboðum o.fl."
          tooltipTitle="Viðskiptavinurinn"
        />

        <GdprCheckbox
          type={RequestGdprDataType.JobApplication}
          label="Starfsumsókn og starfsmannauppl."
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af starfsumsókn, ráðningarsamningi, verktakasamningi, trúnaðaryfirlýsingum o.fl."
          tooltipTitle="Starfsumsókn og starfsmannaupplýsingar"
        />

        <GdprCheckbox
          type={RequestGdprDataType.GeneralAnnouncement}
          label="Almennar tilkynningar og yfirlit"
          gdprData={gdprData}
          setGdprData={setGdprData}
          tooltipText="Afrit af öllum tilkynningum sem bankinn hefur sent viðskiptavini og reikningsyfirlitum frá upphafi viðskipta. Vakin er athygli á því að reikningsyfirlit 6 ár aftur í tímann eru þegar aðgengileg í netbanka viðskiptavinar. Umrædd gögn fela í sér talsvert gagnamagn."
          tooltipTitle="Almennar tilkynningar og yfirlit"
        />
      </Column>
    </>
  );
}
